import { ShippingMethod } from '@/modules/checkout/api';

export function getCheapestShippingMethod(shippingMethods: ShippingMethod[]) {
  return shippingMethods.reduce(
    (cheapestShippingMethod, shippingMethod) =>
      cheapestShippingMethod.price.amount < shippingMethod.price.amount
        ? cheapestShippingMethod
        : shippingMethod,
    shippingMethods[0]
  );
}
